import React from 'react';
import { Box, Card, Typography, alpha } from '@mui/material';

export default function StatusCards({ statuses, statusOrder, counts, total, active, onClick }) {
  return (
    <Box sx={{ display: 'flex', gap: 1.5, mb: 2, width: '100%', flexWrap: 'wrap' }}>
      {statusOrder.map((key) => {
        const s = statuses[key];
        const isActive = active === key;
        const count = counts[key] || 0;
        const pct = total ? Math.round((count / total) * 100) : 0;
        return (
          <Box key={key} sx={{ flex: 1, minWidth: 130 }}>
            <Card
              onClick={() => onClick && onClick(key)}
              sx={{
                cursor: onClick ? 'pointer' : 'default',
                p: 1.5,
                width: '100%',
                borderColor: isActive ? s.color : undefined,
                borderWidth: isActive ? 2 : 1,
                borderStyle: 'solid',
                bgcolor: isActive ? alpha(s.color, 0.12) : undefined,
                transition: 'all .15s',
                '&:hover': { borderColor: alpha(s.color, 0.6) },
              }}
            >
              <Typography sx={{ fontSize: 22, fontWeight: 800, color: s.color, lineHeight: 1.1 }}>
                {count}
              </Typography>
              <Typography variant="body2" sx={{ fontSize: 11, fontWeight: 600, color: 'text.primary', mt: 0.5 }}>
                {s.label}
              </Typography>
              <Typography variant="caption" sx={{ fontSize: 10, color: 'text.secondary' }}>
                {pct}%
              </Typography>
            </Card>
          </Box>
        );
      })}
    </Box>
  );
}
